import { getAccessToken } from "utils/cookies";
import API_MAP from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiAppVersions {
    getAll = ({
        page,
        size,
        search = ''
    }) => {
        return axiosClient.get(`${API_MAP.APP_VERSION.GET_ALL}?page=${page}&size=${size}&s=${search}`)
    }

    get = ({ id }) => {
        return axiosClient.get(`${API_MAP.APP_VERSION.GET}/${id}`)
    }

    create = ({ body }) => {
        return axiosClient.post(`${API_MAP.APP_VERSION.CREATE}`, body)
    }

    update = ({ body, id }) => {
        return axiosClient.post(`${API_MAP.APP_VERSION.UPDATE}/${id}`, body)
    }

    delete = ({ id }) => {
        return axiosClient.post(`${API_MAP.APP_VERSION.DELETE}/${id}`)
    }

    upload = ({ slot, data, onUploadProgress }) => {
        return axiosClient.post(`${API_MAP.APP_VERSION.UPLOAD}?slot=${slot}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: getAccessToken()
            },
            onUploadProgress: onUploadProgress
        })
    }

    release = ({ id }) => {
        return axiosClient.post(`${API_MAP.APP_VERSION.RELEASE}${id}/release`)
    }
}

const apiAppVersions = new ApiAppVersions();

export default apiAppVersions;